var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06234 10.7029C10.1154 7.19429 15.4854 4.88122 18.1722 3.76366C25.8438 0.572786 27.4379 0.0184981 28.4769 0.00019515C28.7054 -0.00383037 29.2163 0.0528033 29.5473 0.321365C29.8268 0.548133 29.9037 0.854464 29.9405 1.06947C29.9773 1.28447 30.0231 1.77425 29.9867 2.15694C29.5709 6.525 27.7721 17.1251 26.857 22.0174C26.4697 24.0875 25.7073 24.7816 24.9691 24.8496C23.3649 24.9972 22.1467 23.7894 20.593 22.7709C18.1617 21.1772 16.7882 20.185 14.4282 18.6298C11.7008 16.8325 13.4688 15.8447 15.0232 14.2303C15.4299 13.8078 22.4981 7.37881 22.6349 6.7956C22.652 6.72266 22.6679 6.45077 22.5063 6.30721C22.3448 6.16364 22.1064 6.21273 21.9344 6.25178C21.6905 6.30712 17.8065 8.87433 10.2823 13.9534C9.17983 14.7104 8.18124 15.0793 7.28655 15.0599C6.30022 15.0386 4.40291 14.5023 2.99246 14.0438C1.26249 13.4814 -0.112459 13.1841 0.00726778 12.2291C0.0696291 11.7316 0.754654 11.2229 2.06234 10.7029Z",
    fill: "url(#paint0_linear_3347_28080)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3347_28080",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 24.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.68aa255b4ed18fb87046add1f86ed3db.svg";
export { ForwardRef as ReactComponent };